import {
  Check,
  ChevronDown,
  DollarSign,
  Download,
  MoreVertical,
  Search,
  IndianRupee,
  Star,
  BadgeCheck,
  X,
  Linkedin,
  Instagram,
  Facebook,
  Eye,
  Pencil,
  EyeOff,
} from "lucide-react";
import {
  FaLinkedin,
  FaInstagram,
  FaFacebook,
  FaWhatsapp,
} from "react-icons/fa";

import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TopNavbar from "../../components/AdminPortal/TopNavbar";
import { useSidebar } from "../../context/SidebarContext";
import { affiliateAPI } from "../../services/AdminPortal/affiliateAPI";
import * as XLSX from "xlsx";
import JSZip from "jszip";
import { toast } from "react-hot-toast";
import { notificationAPI } from "../../services/notificationAPI";
import { useAuth } from "../../context/AuthContext";
import AffiliateInformation from "../../components/AdminPortal/AffiliateInformation";
import ApplicationsList from "../../components/AdminPortal/ApplicationsList";
import CustomerList from "../../components/AdminPortal/CustomerList";
import BankAccountDetails from "../../components/AdminPortal/BankAccountDetails";
import NetworkList from "../../components/AdminPortal/NetworkList";
import EditAffilatePartnerModel from "../../components/AdminPortal/EditAffilatePartnerModel";
export default function AffiliateProfilePage() {
  const { sidebarExpanded, isMobile } = useSidebar();
  const navigate = useNavigate();
  const { id } = useParams();
  const { user } = useAuth();
  const adminId = user?.id;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [profile, setProfile] = useState(null);
  const [applications, setApplications] = useState([]);
  const [selectedApplications, setSelectedApplications] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [filters, setFilters] = useState({
    status: "all",
    dateRange: "all",
    loanType: "all",
  });
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [activeTab, setActiveTab] = useState("affiliate-information");
  const [showEditModal, setShowEditModal] = useState(false);
  const [editFormData, setEditFormData] = useState({
    name: profile?.name || "",
    email: profile?.email || "",
    contact: profile?.contact || "",
    location: profile?.location || "",
    pinCode: profile?.pinCode || "",
    age: profile?.age || "",
    branchName: profile?.branchName || "",
    branchType: profile?.branchType || "",
    branchLocation: profile?.branchLocation || "",
    password: "",
  });
  const [profileImage, setProfileImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(profile?.profileImage || "");
  const [showPassword, setShowPassword] = useState(false);

  // Customer-specific state
  const [customers, setCustomers] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [customerSelectAll, setCustomerSelectAll] = useState(false);
  const [showCustomerFilterPopup, setShowCustomerFilterPopup] = useState(false);
  const [customerFilters, setCustomerFilters] = useState({
    status: "all",
    customerType: "all",
    dateRange: "all",
    city: "all",
  });
  console.log(profile, "lklkkjfkdjfh,gk");
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [customerSearchQuery, setCustomerSearchQuery] = useState("");

  // Fetch customers from backend
  useEffect(() => {
    if (profile) {
      setEditFormData({
        name: profile.name || "",
        email: profile.email || "",
        contact: profile.contact || "",
        location: profile.location || "",
        pinCode: profile.pinCode || "",
        age: profile.age || "",
        branchName: profile.branchName || "",
        branchType: profile.branchType || "",
        branchLocation: profile.branchLocation || "",
        profileImage: profile.profileImage || "",
        password: "",
      });
    }
  }, [profile]);
  const handleUpdateStaff = (updatedStaff) => {
    setProfile((prev) => ({
      ...prev,
      data: { ...prev.data, ...updatedStaff },
    }));
  };

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await affiliateAPI.getAffiliateCustomers(id);
      if (response.success && response.data) {
        setCustomers(response.data);
      } else {
        throw new Error(response.message || "Invalid customer data structure");
      }
    } catch (err) {
      console.error("Error in fetchCustomers:", err);
      setError(
        err.message || "Failed to fetch customers. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  const sendNotification = async (
    userId,
    note,
    notificationType,
    senderUserId
  ) => {
    try {
      const notification = await notificationAPI.sendNotification(
        userId,
        note,
        notificationType,
        senderUserId
      );
      toast.success(`Notification sent: ${note}`);
      console.log("Notification sent:", notification);
    } catch (error) {
      console.error("Error sending notification:", error);
      toast.error("Could not send notification.");
    }
  };
  useEffect(() => {
    fetchData();
    fetchCustomers();
  }, [id]);

  useEffect(() => {
    let filtered = applications;

    // Apply status filter
    if (filters.status !== "all") {
      filtered = filtered.filter((app) => app.status === filters.status);
    }

    // Apply date range filter
    if (filters.dateRange !== "all") {
      const today = new Date();
      const thirtyDaysAgo = new Date(today);
      thirtyDaysAgo.setDate(today.getDate() - 30);

      filtered = filtered.filter((app) => {
        const applicationDate = new Date(app.createdAt);
        if (filters.dateRange === "last30days") {
          return applicationDate >= thirtyDaysAgo;
        }
        return true;
      });
    }

    // Apply loan type filter
    if (filters.loanType !== "all") {
      filtered = filtered.filter((app) => app.loanType === filters.loanType);
    }

    setFilteredApplications(filtered);
  }, [applications, filters]);
  console.log(filteredApplications, "kkkkkkkkkkkkkkkkkkkkk");
  console.log(profile, "ppppppppppppppppp");

  // Customer filtering useEffect
  useEffect(() => {
    let filtered = customers;

    // Apply search filter
    if (customerSearchQuery.trim() !== "") {
      filtered = filtered.filter(
        (customer) =>
          customer.name
            ?.toLowerCase()
            .includes(customerSearchQuery.toLowerCase()) ||
          customer.email
            ?.toLowerCase()
            .includes(customerSearchQuery.toLowerCase()) ||
          customer.contact
            ?.toLowerCase()
            .includes(customerSearchQuery.toLowerCase())
      );
    }

    // Apply status filter
    if (customerFilters.status !== "all") {
      filtered = filtered.filter(
        (customer) => customer.status === customerFilters.status
      );
    }

    // Apply customer type filter
    if (customerFilters.customerType !== "all") {
      filtered = filtered.filter(
        (customer) => customer.customerType === customerFilters.customerType
      );
    }

    // Apply date range filter
    if (customerFilters.dateRange !== "all") {
      const today = new Date();
      const thirtyDaysAgo = new Date(today);
      thirtyDaysAgo.setDate(today.getDate() - 30);
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 7);
      const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);

      filtered = filtered.filter((customer) => {
        const dateOfJoining = new Date(customer.dateOfJoining);
        if (customerFilters.dateRange === "last30days") {
          return dateOfJoining >= thirtyDaysAgo;
        } else if (customerFilters.dateRange === "last7days") {
          return dateOfJoining >= sevenDaysAgo;
        } else if (customerFilters.dateRange === "thisMonth") {
          return dateOfJoining >= thisMonthStart;
        }
        return true;
      });
    }

    // Apply city filter
    if (customerFilters.city !== "all") {
      filtered = filtered.filter(
        (customer) => customer.city === customerFilters.city
      );
    }

    setFilteredCustomers(filtered);
  }, [customers, customerFilters, customerSearchQuery]);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      // Fetch profile data
      const profileData = await affiliateAPI.getAffiliateProfile(id);
      console.log("Raw Profile Data:", profileData);
      console.log("Documents from API:", profileData?.data?.documents);

      // Check if we have valid data
      if (!profileData) {
        throw new Error("No data received from server");
      }

      // Set profile data from affiliatePartner
      if (profileData.success && profileData.data) {
        console.log("Setting profile data:", profileData.data);
        console.log(
          "Document statuses:",
          profileData.data.documents?.map((doc) => ({
            id: doc._id,
            type: doc.type,
            status: doc.status,
          }))
        );
        setProfile(profileData.data);
      } else {
        console.warn("Invalid profile data structure:", profileData);
        throw new Error("Invalid profile data structure");
      }

      // Fetch applications data
      try {
        const applicationsData = await affiliateAPI.getAffiliateApplications(
          id
        );
        console.log("Raw Applications Data:", applicationsData);

        if (applicationsData.success && applicationsData.data) {
          console.log("Setting applications data:", applicationsData.data);
          setApplications(applicationsData.data);
        } else {
          console.warn(
            "Invalid applications data structure:",
            applicationsData
          );
          throw new Error("Invalid applications data structure");
        }
      } catch (err) {
        console.error("Error fetching applications:", err);
        setError("Failed to fetch applications. Please try again later.");
      }
    } catch (err) {
      console.error("Error in fetchData:", err);
      setError(err.message || "Failed to fetch data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedApplications([]);
    } else {
      setSelectedApplications(applications.map((app) => app._id));
    }
    setSelectAll(!selectAll);
  };

  const handleSelectApplication = (id) => {
    if (selectedApplications.includes(id)) {
      setSelectedApplications(
        selectedApplications.filter((appId) => appId !== id)
      );
    } else {
      setSelectedApplications([...selectedApplications, id]);
    }
  };

  // Customer-specific functions
  const handleCustomerSelectAll = () => {
    if (customerSelectAll) {
      setSelectedCustomers([]);
    } else {
      setSelectedCustomers(customers.map((customer) => customer._id));
    }
    setCustomerSelectAll(!customerSelectAll);
  };

  const handleSelectCustomer = (id) => {
    if (selectedCustomers.includes(id)) {
      setSelectedCustomers(
        selectedCustomers.filter((customerId) => customerId !== id)
      );
    } else {
      setSelectedCustomers([...selectedCustomers, id]);
    }
  };

  const handleCustomerFilterChange = (filterType, value) => {
    setCustomerFilters((prev) => ({
      ...prev,
      [filterType]: value,
    }));
  };

  const resetCustomerFilters = () => {
    setCustomerFilters({
      status: "all",
      customerType: "all",
      dateRange: "all",
      city: "all",
    });
  };

  const handleCustomerSearch = (e) => {
    setCustomerSearchQuery(e.target.value);
  };

  const handleStatusUpdate = async (newStatus) => {
    try {
      await affiliateAPI.updateAffiliateStatus(id, newStatus);
      await fetchData(); // Refresh data after status update
    } catch (err) {
      console.error("Error updating status:", err);
      setError("Failed to update status. Please try again.");
    }
  };

  const handleDownloadDocument = async (documentType) => {
    console.log("button is clicking !!");
    try {
      const blob = await affiliateAPI.downloadAffiliateDocument(
        id,
        documentType
      );
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${documentType}_${profile.name}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      console.error("Error downloading document:", err);
      setError("Failed to download document. Please try again.");
    }
  };

  const formatCurrency = (value) => {
    if (value === undefined || value === null) return "₹0";
    // Remove existing currency symbols for parsing, then reformat
    const numValue = Number(String(value).replace(/[^0-9.-]+/g, ""));
    return `₹${numValue.toLocaleString("en-IN")}`;
  };

  const handleExportProfileAndApplicationsData = async () => {
    console.log("handleExportProfileAndApplicationsData called");
    console.log("Current profile state:", profile);

    if (!profile) {
      // Check if profile data itself is available
      toast.error("Profile data is not available to export.");
      console.error("Export aborted: Profile data is null or undefined.");
      return;
    }

    try {
      setLoading(true);
      toast.loading("Preparing export data...");
      console.log("Export process started, loading set to true.");

      const partner = profile; // Use profile directly as it holds the partner details

      // --- Prepare Data for Sheet 1: Partner Profile ---
      const profileDetailsData = [
        { Field: "Partner ID", Value: partner.id || partner._id },
        { Field: "Name", Value: partner.name },
        { Field: "Email", Value: partner.email },
        { Field: "Contact Number", Value: partner.contact },
        { Field: "Joining Date", Value: partner.dateOfJoining },
        { Field: "Affiliate Category", Value: partner.category },
        { Field: "Status", Value: partner.status },
        { Field: "Star Partner", Value: partner.isStarPartner ? "Yes" : "No" }, // Ensure profile has isStarPartner
        {
          Field: "Commission Rate",
          Value: `${partner.commissionDetails?.rate || 0}%`,
        },
      ];
      // Calculate commission details safely
      const totalCommission = Number(
        String(partner.performance?.totalCommission || "0").replace(
          /[^0-9.-]+/g,
          ""
        )
      );
      const pendingCommission = Number(
        String(partner.performance?.pendingCommission || "0").replace(
          /[^0-9.-]+/g,
          ""
        )
      );
      const calculatedPaidCommission = totalCommission - pendingCommission;

      profileDetailsData.push({
        Field: "Total Commission",
        Value: formatCurrency(totalCommission),
      });
      profileDetailsData.push({
        Field: "Paid Commission",
        Value: formatCurrency(calculatedPaidCommission),
      });
      profileDetailsData.push({
        Field: "Pending Commission",
        Value: formatCurrency(pendingCommission),
      });

      // --- Prepare Data for Sheet 2: Applications ---
      const applicationsDataForSheet = filteredApplications.map((app) => ({
        "Application ID": app._id,
        "Applicant Name": app.applicantName,
        "Loan Amount": formatCurrency(app.loanAmount),
        "Loan Type": app.loanType,
        Status: app.status,
        "Date Submitted": new Date(app.createdAt).toLocaleDateString(),
        "Assigned To": app.assignedTo?.name || "Unassigned",
        "Processing Type": app.processingType || "Standard",
      }));

      console.log(
        "Profile details for Excel:",
        JSON.stringify(profileDetailsData, null, 2)
      );
      console.log(
        "Applications data for Excel:",
        JSON.stringify(applicationsDataForSheet, null, 2)
      );

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(profileDetailsData),
        "Partner Profile"
      );

      if (applicationsDataForSheet.length > 0) {
        XLSX.utils.book_append_sheet(
          wb,
          XLSX.utils.json_to_sheet(applicationsDataForSheet),
          "Applications"
        );
      } else {
        XLSX.utils.book_append_sheet(
          wb,
          XLSX.utils.json_to_sheet([
            { Message: "No applications found for this partner." },
          ]),
          "Applications"
        );
      }
      console.log("Excel workbook created.");

      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      console.log("Excel buffer generated, length:", excelBuffer?.byteLength);

      if (!excelBuffer || excelBuffer.byteLength === 0) {
        console.error("Excel buffer is empty or invalid.");
        toast.error("Failed to generate Excel data.");
        setLoading(false);
        toast.dismiss();
        return;
      }

      // Create a zip file
      const zip = new JSZip();
      zip.file(`${partner.name}_Profile_and_Applications.xlsx`, excelBuffer);
      console.log("Excel file added to zip.");

      const zipBlob = await zip.generateAsync({ type: "blob" });
      console.log("Zip blob generated:", zipBlob);

      const url = window.URL.createObjectURL(zipBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${partner.name}_Profile_and_Applications.zip`; // Download as .zip
      document.body.appendChild(a);
      console.log("Download link created, attempting click:", a);
      a.click();
      console.log("Download click triggered.");
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      toast.dismiss();
      toast.success("Partner data exported successfully!");
    } catch (err) {
      console.error("Error exporting profile data:", err);
      toast.dismiss();
      toast.error(
        `Failed to export profile data: ${err.message}. Check console.`
      );
    } finally {
      setLoading(false);
    }
  };
  // const formatCurrency = (value) => {
  //   if (value === undefined || value === null) return '₹0';
  //   // Remove existing currency symbols for parsing, then reformat
  //   const numValue = Number(String(value).replace(/[^0-9.-]+/g, ''));
  //   if (isNaN(numValue)) return '₹0'; // Handle cases where parsing results in NaN
  //   return `₹${numValue.toLocaleString('en-IN')}`;
  // };

  const navigateToApplication = (appId) => {
    navigate(`/admin/loan-applications/approval/${appId}`);
  };

  const handleFilterChange = (filterType, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterType]: value,
    }));
  };

  const resetFilters = () => {
    setFilters({
      status: "all",
      dateRange: "all",
      loanType: "all",
    });
  };

  const openDocumentModal = (document) => {
    console.log("Opening modal with document:", document);
    setSelectedDocument(document);
    setShowDocumentModal(true);
  };

  const closeModal = () => {
    setSelectedDocument(null);
    setShowDocumentModal(false);
  };

  const handleVerifyDocument = async (documentType, status) => {
    console.log("Updating document:", documentType, "with status:", status);
    try {
      const updatedDoc = await affiliateAPI.verifyDocument(
        id,
        documentType,
        status
      );
      console.log("Document status updated:", updatedDoc);

      // Update local state immediately
      setProfile((prevProfile) => ({
        ...prevProfile,
        documents: prevProfile.documents.map((document) =>
          document.type === documentType ? { ...document, status } : document
        ),
      }));

      toast.success("Document status updated successfully");
    } catch (error) {
      console.error("Error updating document status:", error);
      toast.error("Failed to update document status");
    }
    closeModal();
  };

  const handleApproval = async (action) => {
    try {
      console.log(`${action} partner:`, id);

      const newStatus = action === "approve" ? "active" : "inactive";

      // Update backend
      const response = await affiliateAPI.updateStatus(id, newStatus);

      if (response.success) {
        // Update local profile state
        setProfile((prevProfile) => ({
          ...prevProfile,
          status: newStatus.charAt(0).toUpperCase() + newStatus.slice(1),
        }));

        // Show success message
        toast.success(
          `Partner ${
            action === "approve" ? "approved" : "inactived"
          } successfully`
        );
      } else {
        throw new Error(response.message || `Failed to ${action} partner`);
      }
    } catch (err) {
      console.error(`Error in handleApproval (${action}):`, err);
      toast.error(
        err.message || `Failed to ${action} partner. Please try again.`
      );
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#131313] text-white flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-yellow-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[#131313] text-white flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-500 mb-4">{error}</p>
          <button
            onClick={fetchData}
            className="bg-[#FFCA20] text-black px-4 py-2 rounded-md"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="min-h-screen bg-[#131313] text-white flex items-center justify-center">
        <p className="text-gray-400">Profile not found</p>
      </div>
    );
  }

  // Calculate paidCommission for display in JSX
  let paidCommissionForDisplay = 0;
  if (profile && profile.performance) {
    const totalCommission = Number(
      String(profile.performance.totalCommission || "0").replace(
        /[^0-9.-]+/g,
        ""
      )
    );
    const pendingCommission = Number(
      String(profile.performance.pendingCommission || "0").replace(
        /[^0-9.-]+/g,
        ""
      )
    );
    paidCommissionForDisplay = totalCommission - pendingCommission;
  }

  console.log("Profile object:", profile);

  return (
    <div
      className="min-h-screen bg-[#000000] text-white mt-12"
      style={{
        marginLeft: isMobile ? "0" : sidebarExpanded ? "200px" : "60px",
        width: isMobile
          ? "100%"
          : `calc(100% - ${sidebarExpanded ? "200px" : "60px"})`,
      }}
    >
      <TopNavbar />

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <header className="bg-black p-4 flex justify-between items-center border-b border-[#333333]">
          <div>
            <h1 className="text-xl">
              <span
                className="text-[#FFCA20] cursor-pointer"
                onClick={() => navigate("/admin/affiliate-partners")}
              >
                Affiliate Partner Management
              </span>{" "}
              &gt; Affiliate Partner Profile
            </h1>
          </div>
        </header>

        {/* Profile Content */}
        <div className="p-4 sm:p-6 flex-1 overflow-auto">
          {/* Profile Header */}
          <div className="bg-[#131313] border border-[#333333] p-4 sm:p-6 rounded-lg mb-6">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <div className="relative">
                  <div className="w-16 h-16 rounded-full bg-purple-500 flex items-center justify-center overflow-hidden">
                    <img
                      src={
                        profile.profileImage ||
                        "https://www.w3schools.com/howto/img_avatar.png"
                      }
                      alt={profile.name}
                    />
                  </div>
                </div>
                <div className="ml-0 sm:ml-4">
                  <div className="flex flex-col sm:flex-row sm:items-center">
                    <div className="flex items-center">
                      <h2 className="text-2xl font-bold">{profile.name}</h2>
                      {profile.isStarPartner && (
                        <Star className="ml-2 text-[#FFCA20] w-5 h-5" />
                      )}
                      {/* <span className="ml-2 text-green-400 text-sm">
                        {profile.performance?.successRate || 0} Success Rate
                      </span> */}
                    </div>
                    {/* Social Icons with Lucide React */}
                    <div className="flex gap-4 ml-2">
                      {profile.linkedIn && (
                        <a
                          href={profile.linkedIn}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaLinkedin
                            size={30}
                            className="text-blue-600 hover:scale-110 transition"
                          />
                        </a>
                      )}
                      {profile.instagram && (
                        <a
                          href={profile.instagram}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaInstagram
                            size={30}
                            className="text-pink-600 hover:scale-110 transition"
                          />
                        </a>
                      )}
                      {profile.facebook && (
                        <a
                          href={profile.facebook}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaFacebook
                            size={30}
                            className="text-blue-600 hover:scale-110 transition"
                          />
                        </a>
                      )}
                      {profile.whatsapp && (
                        <a
                          href={`https://wa.me/${profile.whatsapp}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaWhatsapp
                            size={30}
                            className="text-green-500 hover:scale-110 transition"
                          />
                        </a>
                      )}
                    </div>
                  </div>
                  <p className="text-gray-400">PARTNER ID {profile.id}</p>
                </div>
              </div>

              <div className="flex gap-2">
                {profile.status.toLowerCase() === "pending" && (
                  <>
                    <button
                      className="bg-green-500 text-white px-4 py-2 rounded-md flex items-center hover:bg-green-600"
                      onClick={() => handleApproval("approve")}
                    >
                      <Check className="w-5 h-5 mr-2" />
                      Approve Partner
                    </button>
                    <button
                      className="bg-red-500 text-white px-4 py-2 rounded-md flex items-center hover:bg-red-600"
                      onClick={() => handleApproval("inactive")}
                    >
                      <X className="w-5 h-5 mr-2" />
                      Reject Partner
                    </button>
                  </>
                )}
                <button
                  className="bg-[#FFCA20] text-black px-4 py-2 rounded-md flex items-center"
                  onClick={() => setIsEditModalOpen(true)}
                >
                  Edit Profile
                </button>

                <button
                  className="bg-[#FFCA20] text-black px-4 py-2 rounded-md flex items-center"
                  onClick={handleExportProfileAndApplicationsData}
                >
                  <Download className="w-5 h-5 mr-2" />
                  Export Data
                </button>
              </div>
            </div>

            <div className="flex flex-wrap gap-y-4 mt-4">
              <div className="w-full sm:w-1/2 md:w-1/3 lg:w-auto border-b sm:border-b-0 sm:border-r border-[#333333] pr-4 pb-2 sm:pb-0">
                <p className="text-[#F3F3F3] text-12px">Contact Number</p>
                <p className="text-[#F3F3F3] text-16px">
                  +91 {profile.contact}
                </p>
              </div>
              <div className="w-full sm:w-1/2 md:w-1/3 lg:w-auto border-b sm:border-b-0 sm:border-r border-[#333333] pr-4 pb-2 sm:pb-0">
                <p className="text-[#F3F3F3] text-12px">Email ID</p>
                <p className="text-[#F3F3F3] text-16px">{profile.email}</p>
              </div>
              <div className="w-full sm:w-1/2 md:w-1/3 lg:w-auto border-b sm:border-b-0 sm:border-r border-[#333333] pr-4 pb-2 sm:pb-0">
                <p className="text-[#F3F3F3] text-12px">Date of Joining</p>
                <p className="text-[#F3F3F3] text-16px">
                  {profile.joiningDate || "N/A"}
                </p>
              </div>
              <div className="w-full sm:w-1/2 md:w-1/3 lg:w-auto border-b sm:border-b-0 sm:border-r border-[#333333] pr-4 pb-2 sm:pb-0">
                <p className="text-[#F3F3F3] text-12px">Affiliate Category</p>
                <p className="text-[#F3F3F3] text-16px">{profile.category}</p>
              </div>
              <div className="w-full sm:w-1/2 md:w-1/3 lg:w-auto border-b sm:border-b-0 sm:border-r border-[#333333] pr-4 pb-2 sm:pb-0">
                <p className="text-[#F3F3F3] text-12px">Location</p>
                <p className="text-[#F3F3F3] text-16px">{profile.location}</p>
              </div>
              <div className="w-full sm:w-1/2 md:w-1/3 lg:w-auto border-b sm:border-b-0 sm:border-r border-[#333333] pr-4 pb-2 sm:pb-0">
                <p className="text-[#F3F3F3] text-12px">PIN</p>
                <p className="text-[#F3F3F3] text-16px">{profile.pinCode}</p>
              </div>
              <div className="w-full sm:w-1/2 md:w-1/3 lg:w-auto">
                <p className="text-[#F3F3F3] text-12px">Age</p>
                <p className="text-[#F3F3F3] text-16px">{profile.age}</p>
              </div>
            </div>
            {/* ✅ Branch Details */}
            <div className="w-full mt-4">
              <h3 className="text-sm font-semibold text-[#FFCA20] mb-2">
                Branch Details
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <div className="text-xs text-gray-400">Branch Name</div>
                  <div>{profile.branchName}</div>
                </div>
                <div>
                  <div className="text-xs text-gray-400">Branch Type</div>
                  <div>
                    {profile.branchType === "district"
                      ? "District Level"
                      : profile.branchType === "mandal"
                      ? "Mandal Level"
                      : profile.branchType === "village"
                      ? "Village Level"
                      : profile.branchType}
                  </div>
                </div>
                <div>
                  <div className="text-xs text-gray-400">Branch Location</div>
                  <div>{profile.branchLocation}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="bg-[#000000] p-4 pl-4 sm:pl-8 mb-6">
            <div className="w-full overflow-x-auto scrollbar-hide">
              <div className="flex flex-nowrap pb-2 whitespace-nowrap">
                <button
                  onClick={() => setActiveTab("customer-list")}
                  className={`tab-button px-3 sm:px-4 py-2 mr-2 sm:mr-6 text-sm sm:text-base ${
                    activeTab === "customer-list"
                      ? "active-tab-border"
                      : "inactive-tab"
                  }`}
                >
                  Customer List
                </button>
                <button
                  onClick={() => setActiveTab("network-list")}
                  className={`tab-button px-3 sm:px-4 py-2 mr-2 sm:mr-6 text-sm sm:text-base ${
                    activeTab === "network-list"
                      ? "active-tab-border"
                      : "inactive-tab"
                  }`}
                >
                  Network List
                </button>

                <button
                  onClick={() => setActiveTab("application-list")}
                  className={`tab-button px-3 sm:px-4 py-2 mr-2 sm:mr-6 text-sm sm:text-base ${
                    activeTab === "application-list"
                      ? "active-tab-border"
                      : "inactive-tab"
                  }`}
                >
                  Application List
                </button>

                <button
                  onClick={() => setActiveTab("affiliate-information")}
                  className={`tab-button px-3 sm:px-4 py-2 mr-2 sm:mr-6 text-sm sm:text-base ${
                    activeTab === "affiliate-information"
                      ? "active-tab-border"
                      : "inactive-tab"
                  }`}
                >
                  Affiliate Info
                </button>

                <button
                  onClick={() => setActiveTab("affiliate-bank-account-details")}
                  className={`tab-button px-3 sm:px-4 py-2 text-sm sm:text-base ${
                    activeTab === "affiliate-bank-account-details"
                      ? "active-tab-border"
                      : "inactive-tab"
                  }`}
                >
                  Bank Details
                </button>
              </div>
            </div>
          </div>

          {/* Tab Content */}
          {activeTab === "affiliate-information" && (
            <AffiliateInformation
              profile={profile}
              formatCurrency={formatCurrency}
              paidCommissionForDisplay={paidCommissionForDisplay}
              openDocumentModal={openDocumentModal}
            />
          )}

          {activeTab === "customer-list" && (
            <CustomerList
              profile={profile}
              customers={filteredCustomers}
              selectedCustomers={selectedCustomers}
              selectAll={customerSelectAll}
              showFilterPopup={showCustomerFilterPopup}
              filters={customerFilters}
              handleSelectAll={handleCustomerSelectAll}
              handleSelectCustomer={handleSelectCustomer}
              handleFilterChange={handleCustomerFilterChange}
              resetFilters={resetCustomerFilters}
              setShowFilterPopup={setShowCustomerFilterPopup}
              handleSearch={handleCustomerSearch}
              searchQuery={customerSearchQuery}
            />
          )}
          {activeTab === "network-list" && (
            <NetworkList
              selectedCustomers={selectedCustomers}
              Id={id}
              handleSelectCustomer={handleSelectCustomer}
            />
          )}

          {activeTab === "application-list" && (
            <ApplicationsList
              profile={profile}
              filteredApplications={filteredApplications}
              selectedApplications={selectedApplications}
              selectAll={selectAll}
              showFilterPopup={showFilterPopup}
              filters={filters}
              handleSelectAll={handleSelectAll}
              handleSelectApplication={handleSelectApplication}
              handleStatusUpdate={handleStatusUpdate}
              handleDownloadDocument={handleDownloadDocument}
              navigateToApplication={navigateToApplication}
              handleFilterChange={handleFilterChange}
              resetFilters={resetFilters}
              setShowFilterPopup={setShowFilterPopup}
              formatCurrency={formatCurrency}
            />
          )}

          {activeTab === "affiliate-bank-account-details" && (
            <>
              {console.log("BankAccountDetails partnerId:", profile?._id)}
              <BankAccountDetails
                bankDetails={profile.accountDetails || profile.bankDetails}
                partnerId={profile._id}
                onSave={fetchData}
              />
            </>
          )}
        </div>
      </div>

      {/* Document Modal */}
      {showDocumentModal && selectedDocument && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-[#131313] p-4 rounded-lg max-w-4xl w-full mx-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Document Preview</h3>
              <button
                onClick={closeModal}
                className="text-gray-400 hover:text-white"
              >
                ✕
              </button>
            </div>
            <div className="relative w-full h-[70vh]">
              <img
                src={selectedDocument.filePath}
                alt={selectedDocument.fileName}
                className="w-full h-full object-contain"
                ame="w-full h-full object-contain"
              />
            </div>
            {/* Verification Actions */}
            {!["verified", "rejected"].includes(
              selectedDocument.status?.toLowerCase()
            ) && (
              <div className="p-4 flex justify-end space-x-4">
                <button
                  onClick={async () => {
                    console.log("Selected document:", selectedDocument);
                    if (!selectedDocument.type) {
                      console.error("Document type is missing");
                      toast.error("Document type is missing");
                      return;
                    }

                    try {
                      await sendNotification(
                        profile._id,
                        "Please reupload your document",
                        "Admin",
                        adminId
                      );
                    } catch (error) {
                      console.error("Failed to send notification:", error);
                    }

                    await handleVerifyDocument(
                      selectedDocument.type,
                      "rejected"
                    );
                  }}
                  className="bg-red-500/20 border-red-500 border-2 hover:bg-red-800 px-4 text-red-500 font-medium p-2 rounded flex items-center"
                >
                  Reject <X className="w-4 h-4 ml-2" />
                </button>
                <button
                  onClick={async () => {
                    console.log("Selected document:", selectedDocument);
                    if (!selectedDocument.type) {
                      console.error("Document type is missing");
                      toast.error("Document type is missing");
                      return;
                    }
                    await handleVerifyDocument(
                      selectedDocument.type,
                      "verified"
                    );
                  }}
                  className="bg-green-300/20 border-green-500 border-2 hover:bg-green-800 px-4 text-green-500 font-medium p-2 rounded flex items-center"
                >
                  Verify <Check className="w-4 h-4 ml-2" />
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      <EditAffilatePartnerModel
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        staffData={profile}
        onUpdate={handleUpdateStaff}
      />
    </div>
  );
}
